import React, { useEffect, useState } from "react";
import Banner2 from "../../components/Banner2";
import { Col, Container, Form, Row, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import "react-phone-input-2/lib/plain.css";
import { createProductInquiry } from "../../features/productInquiry";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import SelectDropdown from "../../components/SelectDropdown";
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import MobileNumberInput from '../../components/MobileNumberInput/index';

const MedicalInsurance = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // State for form data and validation errors
  const [formData, setFormData] = useState({
    plan_type: "individual", // Default value
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
    // Clear the specific error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

      const getMaxDOB = () => {
      const today = new Date();
      return today.toISOString().split("T")[0]; // yyyy-mm-dd format
    };

    const maxDOB = getMaxDOB();

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Common Validation
    if (!formData.email) {
      newErrors.email = t("validation.email_required");
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = t("validation.email_invalid");
    }

    // Branching Validation
    if (formData.plan_type === "individual") {
      if (!formData.title) newErrors.title = t("validation.title_required");
      if (!formData.name || formData.name.trim() === "") {
        newErrors.name = t("validation.name_required");
      }
      if (!formData.date_of_birth) {
        newErrors.date_of_birth = t("validation.dob_required");
      }
      if (!formData.account_type) {
        newErrors.account_type = t("validation.selection_required");
      }
    } else if (formData.plan_type === "corporate") {
      if (!formData.company_name) newErrors.company_name = t("validation.company_required");
      if (!formData.industry) newErrors.industry = t("validation.industry_required");
      if (!formData.no_employees || formData.no_employees <= 0) {
        newErrors.no_employees = t("validation.invalid_employees");
      }
      if (!formData.policy_expiry_date) {
        newErrors.policy_expiry_date = t("validation.expiry_required");
      }
    }



    if (!formData.email) {
      newErrors.email = t("validation.email_required");
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = t("validation.email_invalid");
    }

    // ✅ Add this
    if (!formData.mobile_number || formData.mobile_number.trim() === "") {
      newErrors.mobile_number = t("validation.phone_required");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error(t("validation.please_fix_errors"));
      return;
    }

    try {
      const response = await dispatch(
        createProductInquiry({
          form_data: formData,
          product_details: JSON.parse(localStorage.getItem("product_details")),
        })
      ).unwrap();

      if (response.success) {
        toast.success(t("success_res"));
        navigate("/");
      }
    } catch (error) {
      console.error("Error submitting inquiry:", error);
      toast.error(t("error_res"));
    }
  };

  // Country code logic
  const [countryCodes, setCountryCodes] = useState([]);
  const [selectedCode, setSelectedCode] = useState("");

  useEffect(() => {
    const codes = Array.from(
      new Map(
        getCountries().map((code) => {
          const dialCode = "+" + getCountryCallingCode(code);
          return [dialCode, { label: dialCode, value: dialCode }];
        })
      ).values()
    ).sort((a, b) => a.value.localeCompare(b.value));

    setCountryCodes(codes);
    setSelectedCode(codes[0]);
  }, []);

  return (
    <>
      <Banner2 classList="bg-grey">
        <Container>
          <Row>
            <Col className="offset-md-3" md={9}>
              <div className="insurance-title">
                <h3 className="title text-capitalize text-center">
                  {t("medical_insurance.description")}
                </h3>
              </div>
            </Col>
            <Col md={3}>
              <div className="policy-box">
                <div className="icon-image">
                  <img
                    src={require("../../assets/SVG/1-23.svg").default}
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <p className="title">{t("medical_insurance.title")}</p>
              </div>
            </Col>
            <Col md={9}>
              <div className="policy-form">
                <div className="policy-formBox why-us-form">
                  <Form noValidate onSubmit={handleSubmit}>
                    <Row>
                      <Col md={12}>
                        <h5 className="subtitle">
                          {t("medical_insurance.choose_your_plan")}
                        </h5>
                        <div className="flex-content">
                          <div className="form-group custom-checkbox">
                            <Form.Check
                              type="radio"
                              name="plan_type"
                              id="plan_type_individual"
                              label={t("medical_insurance.form.individual")}
                              checked={formData.plan_type === "individual"}
                              onChange={() => handleInputChange("plan_type", "individual")}
                            />
                          </div>
                          <div className="form-group custom-checkbox">
                            <Form.Check
                              type="radio"
                              name="plan_type"
                              id="plan_type_corporate"
                              label={t("medical_insurance.form.corporate")}
                              checked={formData.plan_type === "corporate"}
                              onChange={() => handleInputChange("plan_type", "corporate")}
                            />
                          </div>
                        </div>
                      </Col>

                      {formData?.plan_type === "individual" && (
                        <>
                          <Col lg={4} md={6}>
                            <div className="form-group">
                              <SelectDropdown
                                name="title"
                                placeholder={t("medical_insurance.form.title.placeholder")}
                                options={[
                                  { value: "mr", label: t("medical_insurance.form.title.option1") },
                                  { value: "miss", label: t("medical_insurance.form.title.option2") },
                                  { value: "mrs", label: t("medical_insurance.form.title.option3") },
                                ]}
                                handleOnChange={(name, val) => handleInputChange(name, val)}
                              />
                              {errors.title && <small className="text-danger">{errors.title}</small>}
                            </div>
                          </Col>
                          <Col lg={8} md={6}>
                            <div className="form-group">
                              <Form.Control
                                type="text"
                                name="name"
                                isInvalid={!!errors.name}
                                placeholder={t("medical_insurance.form.name")}
                                className="form-control element-style"
                                onChange={(e) => handleInputChange("name", e.target.value)}
                              />
                              <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                            </div>
                          </Col>

                          <Col lg={12} md={12}>
                            <div className="form-group">
                              <Form.Label>{t("medical_insurance.form.dob")}</Form.Label>
                              <Form.Control
                                type="date"
                                max={maxDOB}
                                name="date_of_birth"
                                isInvalid={!!errors.date_of_birth}
                                className="form-control element-style"
                                value={formData?.date_of_birth || ""}
                                onChange={(e) => handleInputChange("date_of_birth", e.target.value)}
                              />
                              <Form.Control.Feedback type="invalid">{errors.date_of_birth}</Form.Control.Feedback>
                            </div>
                          </Col>

                          <Col md={12}>
                            <div className="flex-content">
                              <div className="form-group custom-checkbox">
                                <Form.Check
                                  type="radio"
                                  name="account_type"
                                  id="salaried"
                                  label={t("medical_insurance.form.salaried")}
                                  checked={formData.account_type === "salaried"}
                                  isInvalid={!!errors.account_type}
                                  onChange={() => handleInputChange("account_type", "salaried")}
                                />
                              </div>
                              <div className="form-group custom-checkbox">
                                <Form.Check
                                  type="radio"
                                  name="account_type"
                                  id="business"
                                  label={t("medical_insurance.form.business")}
                                  checked={formData.account_type === "business"}
                                  isInvalid={!!errors.account_type}
                                  onChange={() => handleInputChange("account_type", "business")}
                                />
                              </div>
                            </div>
                            {errors.account_type && <small className="text-danger">{errors.account_type}</small>}
                          </Col>
                        </>
                      )}

                      {formData?.plan_type === "corporate" && (
                        <>
                          <Col md={12}>
                            <div className="form-group">
                              <Form.Control
                                type="text"
                                name="company_name"
                                isInvalid={!!errors.company_name}
                                placeholder={t("medical_insurance.form.company_name")}
                                className="form-control element-style"
                                onChange={(e) => handleInputChange("company_name", e.target.value)}
                              />
                              <Form.Control.Feedback type="invalid">{errors.company_name}</Form.Control.Feedback>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="form-group">
                              <Form.Control
                                type="text"
                                name="industry"
                                isInvalid={!!errors.industry}
                                placeholder={t("medical_insurance.form.industry")}
                                className="form-control element-style"
                                onChange={(e) => handleInputChange("industry", e.target.value)}
                              />
                              <Form.Control.Feedback type="invalid">{errors.industry}</Form.Control.Feedback>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="form-group">
                              <Form.Control
                                type="number"
                                name="no_employees"
                                isInvalid={!!errors.no_employees}
                                placeholder={t("medical_insurance.form.no_employees")}
                                className="form-control element-style"
                                onChange={(e) => handleInputChange("no_employees", e.target.value)}
                              />
                              <Form.Control.Feedback type="invalid">{errors.no_employees}</Form.Control.Feedback>
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="form-group">
                              <Form.Label>{t("work_insurance.form.policy_expiry_date")}</Form.Label>
                              <Form.Control
                                type="date"
                                name="policy_expiry_date"
                                isInvalid={!!errors.policy_expiry_date}
                                className="form-control element-style"
                                value={formData?.policy_expiry_date || ""}
                                onChange={(e) => handleInputChange("policy_expiry_date", e.target.value)}
                              />
                              <Form.Control.Feedback type="invalid">{errors.policy_expiry_date}</Form.Control.Feedback>
                            </div>
                          </Col>
                        </>
                      )}

                      <Col md={6}>
                        <div className="form-group">
                          <Form.Control
                            type="email"
                            name="email"
                            isInvalid={!!errors.email}
                            placeholder={t("medical_insurance.form.email")}
                            className="form-control element-style"
                            onChange={(e) => handleInputChange("email", e.target.value)}
                          />
                          <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                        </div>
                      </Col>

                      <Col md={6}>
                        <MobileNumberInput
                          onChange={({ countryCode, number }) => {
                            handleInputChange("country_code", countryCode);
                            handleInputChange("mobile_number", number);
                          }}
                        />
                        {errors.mobile_number && <small className="text-danger d-block mt-1">{errors.mobile_number}</small>}
                      </Col>

                      <Col md={12}>
                        <div className="form-submitbtn">
                          <button
                            type="submit"
                            className="btn h-btn"
                          >
                            {t("medical_insurance.form.confirm")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Banner2>
    </>
  );
};

export default MedicalInsurance;